document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-mobile-menu]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuButton && mobileNav) {
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.querySelectorAll('[data-thumb]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const mainImage = document.querySelector('[data-main-product-image]');
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.src;
      mainImage.removeAttribute('srcset');
      document.querySelectorAll('[data-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumbnail.classList.add('is-active');
    });
  });

  const revealItems = document.querySelectorAll('.zq-reveal');
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const delay = Number(entry.target.dataset.revealDelay || 0);
        window.setTimeout(() => entry.target.classList.add('is-visible'), delay);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -35px' });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-product-showcase]').forEach((showcase) => {
    const buttons = showcase.querySelectorAll('[data-product-filter]');
    const cards = showcase.querySelectorAll('[data-product-card]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.productFilter;
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        cards.forEach((card) => {
          const visible = filter === 'all' || card.dataset.series === filter;
          card.hidden = !visible;
          if (visible) window.requestAnimationFrame(() => card.classList.add('is-visible'));
        });
      });
    });
  });

  document.querySelectorAll('[data-model-finder]').forEach((finder) => {
    const dataElement = finder.querySelector('[data-finder-catalog]');
    if (!dataElement) return;
    const catalog = JSON.parse(dataElement.textContent);
    let width = '119';
    let levels = '3';
    const render = () => {
      const model = `${width}-${levels}`;
      const item = catalog[model];
      if (!item) return;
      finder.querySelector('[data-finder-model]').textContent = model;
      finder.querySelector('[data-finder-price]').textContent = item.price;
      finder.querySelector('[data-finder-dimensions]').textContent = item.dimensions;
      finder.querySelector('[data-finder-link]').dataset.targetSeries = width;
    };
    finder.querySelectorAll('[data-finder-width]').forEach((button) => button.addEventListener('click', () => {
      width = button.dataset.finderWidth;
      finder.querySelectorAll('[data-finder-width]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      render();
    }));
    finder.querySelectorAll('[data-finder-levels]').forEach((button) => button.addEventListener('click', () => {
      levels = button.dataset.finderLevels;
      finder.querySelectorAll('[data-finder-levels]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      render();
    }));
    finder.querySelector('[data-finder-link]').addEventListener('click', (event) => {
      const target = document.querySelector(`[data-product-filter="${event.currentTarget.dataset.targetSeries}"]`);
      if (target) target.click();
    });
    render();
  });

  document.querySelectorAll('[data-quick-order-form]').forEach((form) => {
    const modelSelect = form.querySelector('[data-quick-order-model]');
    const modelOutput = form.querySelector('[data-quick-order-model-output]');
    const priceOutput = form.querySelector('[data-quick-order-price-output]');
    const dimensionsOutput = form.querySelector('[data-quick-order-dimensions-output]');
    const updateSummary = () => {
      const option = modelSelect?.selectedOptions[0];
      if (!option) return;
      if (modelOutput) modelOutput.textContent = option.value;
      if (priceOutput) priceOutput.textContent = option.dataset.price || '';
      if (dimensionsOutput) dimensionsOutput.textContent = option.dataset.dimensions || '';
    };
    modelSelect?.addEventListener('change', updateSummary);
    updateSummary();
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const data = new FormData(form);
      const option = modelSelect?.selectedOptions[0];
      const message = [
        'طلب جديد من الموقع ZINDAQA',
        '',
        `الموديل: ${data.get('model')}`,
        `المقاس: ${option?.dataset.dimensions || ''}`,
        `الثمن: ${option?.dataset.price || ''} درهم`,
        `الكمية: ${data.get('quantity')}`,
        `طريقة الأداء: ${data.get('payment')}`,
        '',
        `الاسم الكامل: ${data.get('full_name')}`,
        `رقم الهاتف: ${data.get('phone')}`,
        `المدينة: ${data.get('city')}`,
        `العنوان: ${data.get('address')}`
      ].join('\n');
      const number = String(form.dataset.whatsappNumber || '').replace(/\D/g, '');
      if (!number) return;
      const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
      const opened = window.open(url, '_blank', 'noopener');
      if (!opened) window.location.href = url;
    });
  });

  const toast = document.querySelector('[data-cart-toast]');
  let toastTimer;
  const showToast = () => {
    if (!toast) return;
    toast.hidden = false;
    toast.setAttribute('aria-hidden', 'false');
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 4500);
  };
  const updateCartCount = async () => {
    if (!window.zindaqaRoutes) return;
    const response = await fetch(window.zindaqaRoutes.cartJson, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; count.classList.toggle('is-empty', cart.item_count === 0); });
  };

  document.querySelectorAll('.quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !window.zindaqaRoutes) return;
      event.preventDefault();
      const button = form.querySelector('[data-quick-add-button]');
      if (!button || button.disabled) return;
      button.disabled = true;
      button.classList.add('is-loading');
      try {
        const response = await fetch(window.zindaqaRoutes.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
        if (!response.ok) throw new Error('cart');
        await updateCartCount();
        showToast();
        button.classList.add('is-success');
      } catch (error) {
        form.submit();
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
        window.setTimeout(() => button.classList.remove('is-success'), 1400);
      }
    });
  });

  document.querySelector('[data-toast-close]')?.addEventListener('click', () => {
    toast?.classList.remove('is-visible');
    toast?.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll('[data-quantity-change]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange));
      input.value = String(next);
    });
  });

  const variantSelect = document.querySelector('[data-variant-select]');
  const variantInput = document.querySelector('[data-product-variant-id]');
  if (variantSelect && variantInput) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      variantInput.value = option.value;
      document.querySelectorAll('[data-product-price], [data-sticky-price]').forEach((price) => { price.textContent = option.dataset.price; });
    });
  }

  const mainAdd = document.querySelector('[data-main-add]');
  const stickyBar = document.querySelector('[data-product-sticky]');
  const stickyButton = document.querySelector('[data-sticky-add]');
  stickyButton?.addEventListener('click', () => mainAdd?.click());
  if (mainAdd && stickyBar && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => stickyBar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    stickyObserver.observe(mainAdd);
  }

  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.querySelectorAll('[data-luxury-stage]').forEach((stage) => {
      stage.addEventListener('pointermove', (event) => {
        const rect = stage.getBoundingClientRect();
        const rotateY = ((event.clientX - rect.left) / rect.width - 0.5) * 7;
        const rotateX = ((event.clientY - rect.top) / rect.height - 0.5) * -7;
        stage.style.transform = `perspective(1200px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      });
      stage.addEventListener('pointerleave', () => {
        stage.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg)';
      });
    });
    document.querySelectorAll('.product-card').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const rotateY = ((event.clientX - rect.left) / rect.width - 0.5) * 4;
        const rotateX = ((event.clientY - rect.top) / rect.height - 0.5) * -4;
        card.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-5px)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }
});
